import { useEffect, useState } from "react";
import api, { fmtMoney } from "../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Award } from "lucide-react";

export const GRADE_CLS = { A: "bg-emerald-600 text-white", B: "bg-sky-600 text-white", C: "bg-amber-500 text-white", D: "bg-red-600 text-white", "—": "bg-muted text-muted-foreground" };
const RESULT = { on_time: ["A tiempo", "text-emerald-700"], late: ["Tarde", "text-red-700"], overdue: ["Vencida sin recibir", "text-red-700"],
                 pending: ["En curso", "text-muted-foreground"], no_date: ["Sin fecha", "text-muted-foreground"] };

export function useSupplierEvaluation(enabled = true) {
  const [data, setData] = useState([]);
  useEffect(() => { if (enabled) api.get("/suppliers/evaluation").then((r) => setData(r.data)).catch(() => {}); }, [enabled]);
  return data;
}

export function GradeBadge({ ev, onClick }) {
  if (!ev) return null;
  return (
    <button onClick={onClick} data-testid={`supplier-grade-${ev.supplier_id}`} title="Evaluación de puntualidad"
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-black ${GRADE_CLS[ev.grade] || GRADE_CLS["—"]}`}>
      <Award size={10} /> {ev.grade}{ev.score != null && <span className="font-medium opacity-80">· {ev.score}</span>}
    </button>
  );
}

const Stat = ({ label, value, testid }) => (
  <div className="border p-2"><div className="text-[9px] font-bold uppercase tracking-widest text-muted-foreground">{label}</div>
    <div className="text-lg font-black tabular-nums" data-testid={testid}>{value}</div></div>
);

export function SupplierEvaluationDialog({ ev, onClose }) {
  return (
    <Dialog open={!!ev} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="supplier-eval-dialog">
        {ev && (
          <>
            <DialogHeader>
              <DialogTitle className="uppercase font-black flex items-center gap-3">{ev.supplier_name}
                <span className={`px-2 py-0.5 text-xs font-black ${GRADE_CLS[ev.grade]}`}>{ev.grade}{ev.score != null && ` · ${ev.score}`}</span>
              </DialogTitle>
              <DialogDescription className="text-xs">Puntualidad = entregas completas a tiempo vs fecha prometida (70%) + tasa de confirmación de OC (30%).</DialogDescription>
            </DialogHeader>
            <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
              <Stat label="OCs" value={ev.total_pos} />
              <Stat label="Evaluadas" value={ev.evaluated} />
              <Stat label="A tiempo" value={ev.on_time_pct == null ? "—" : `${ev.on_time_pct}%`} testid="supplier-eval-ontime" />
              <Stat label="Tarde" value={ev.late} />
              <Stat label="Retraso prom." value={`${ev.avg_delay_days} d`} />
              <Stat label="Confirmación" value={ev.confirmation_pct == null ? "—" : `${ev.confirmation_pct}%`} />
            </div>
            <div className="tbl-wrap"><table className="tbl">
              <thead><tr><th>OC</th><th>Prometida</th><th>Recibida</th><th className="num">Retraso</th><th>Resultado</th><th>Confirmación</th><th className="num">Total</th></tr></thead>
              <tbody>
                {ev.orders.map((o) => { const [lbl, cls] = RESULT[o.result] || RESULT.pending; return (
                  <tr key={o.number}>
                    <td className="font-bold">{o.number}</td><td className="tabular-nums">{o.promised || "—"}</td><td className="tabular-nums">{o.received || "—"}</td>
                    <td className="num">{o.delay_days ? `${o.delay_days} d` : "—"}</td><td className={`font-bold ${cls}`}>{lbl}</td>
                    <td className="text-[10px] uppercase text-muted-foreground">{o.confirmation || "—"}</td><td className="num">{fmtMoney(o.total)} {o.currency}</td>
                  </tr>); })}
              </tbody>
            </table></div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
